export const COMPLAIN_LIST_SUCCESS = 'COMPLAIN_LIST_SUCCESS';
export const COMPLAIN_LIST_LOADING = 'COMPLAIN_LIST_LOADING';
export const COMPLAIN_LIST_FAILED = 'COMPLAIN_LIST_FAILED';
export const COMPLAIN_LIST_LOADDATA = 'COMPLAIN_LIST_LOADDATA';